import { NgModule } from '@angular/core';
import { GetLookupLabelPipe } from '../../pipes/get-lookup-label.pipe';
import { FilterByPipe } from '../../pipes/filter-by.pipe';
import { NoWhitespaceDirective } from '../../directives/no-whitespace.directive';
import { filterByNotEqualPipe } from '../../pipes/filter-by-not-equal.pipe';
import { NotEqualDirective } from '../../directives/not-equal.directive';

@NgModule({
  imports: [
  ],
  declarations: [
    FilterByPipe,
    filterByNotEqualPipe,
    GetLookupLabelPipe,
    NoWhitespaceDirective,
    NotEqualDirective
  ],
  exports: [
    FilterByPipe,
    filterByNotEqualPipe,
    GetLookupLabelPipe,
    NoWhitespaceDirective,
    NotEqualDirective
  ]
})
export class LinkSharedModule { }
